// JKwan 20210712 - function to fix RC's product handles in the mini cart and cart page (per RC instructions)

function rcFixProductHandles() {  
  var links = document.querySelectorAll('div.ajax-cart__product-title > a[data-rc-recurring]:not([data-rc-enabled])');
  
  if (links.length) {
    links.forEach(function(link) {
      var productURL = link.getAttribute('href');
      var n = productURL.indexOf('?');
      var r = n !== -1 ? productURL.split('?')[1] : '';
      var s = productURL.substring(0, n !== -1 ? n : productURL.length);
      
      if (parseInt(s.slice(-1)) > 2){
        productURL = s.substr(0, s.length - 2) + '-' + (parseInt(s.slice(-1)) - 1);
      } else {
        productURL = s.substr(0, s.length - 2);
      }
      
      if (r) {
        productURL += '?' + r;
      }
      
      link.setAttribute('href', productURL);
      link.setAttribute('data-rc-enabled', true);
    });
  }
}
